// pages/ForgotPassword.jsx
import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assets/css/Login.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  
  const { forgotPassword } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Please enter your email');
      return;
    }
    
    try {
      setError('');
      setLoading(true);
      const result = await forgotPassword(email);
      
      if (result.success) {
        setSuccess(true);
        toast.success('Email sent successfully! Check your inbox.', {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        setError(result.message || 'Failed to send email');
        toast.error(result.message || 'Failed to send email');
      }
    } catch (err) {
      setError('Failed to send email');
      toast.error('Failed to send email');
    }
    
    setLoading(false);
  };

  if (success) {
    return (
      <>
        <Container fluid className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
          <Row className="w-100 justify-content-center">
            <Col md={4} sm={8} xs={12}>
              <Card className="shadow">
                <Card.Body className="p-5 text-center">
                  <h2 className="mb-4">Email Sent!</h2>
                  <p className="text-muted">Please check your email for the reset link.</p>
                  <Button 
                    variant="primary" 
                    onClick={() => navigate('/admin/login')}
                    className="w-100 login-btn"
                  >
                    Back to Login
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    );
  }

  return (
    <>
      <Container fluid className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
        <Row className="w-100 justify-content-center">
          <Col md={4} sm={8} xs={12}>
            <Card className="shadow">
              <Card.Body className="p-5">
                <h2 className="text-center mb-4">Passwort vergessen?</h2>
                <p className="text-center">Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen</p>

                {error && <Alert variant="danger">{error}</Alert>}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      disabled={loading}
                    />
                  </Form.Group>
                  <Button
                    disabled={loading}
                    className="w-100 login-btn"
                    variant="primary"
                    type="submit"
                  >
                    {loading ? 'Sending Email...' : 'Send Email'}
                  </Button>

                  <div className="text-start mt-3">
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      onClick={() => navigate('/admin/login')}
                      disabled={loading}
                    >
                      ← Zurück zum Login
                    </button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}